<div #layoutTopbar [style.display]="isVisible ? 'liline-block' : 'none'" class="layout-topbar"
  [ngClass]="{ 'at-log-in': true }">
  <div class="p-d-flex p-ai-center">
    <img class="only-for-desktop" [src]="'./assets/images/header-logo-holding.svg'"
     alt="logo" [srcset]="'./assets/images/header-logo-holding.svg'"
       [style.cursor]="'default'" />
  </div>
  <div class="mobile-logo-container">
    <img [src]="'./assets/images/header-logo-holding.svg'
      " alt="logo" [srcset]="'./assets/images/header-logo-holding.svg'"
      [style.cursor]="'default'" />
  </div>
</div>
